import { useAppSelector } from '@/hooks/useRedux'
import { userSelector } from '@/pages/user/selectors'

export const useUserDetails = () => {
  const { user } = useAppSelector(userSelector)

  return {
    'User ID': user?.id,
    Email: user?.email,
    Name: user?.fullName,
  }
}
